export const SET_COURSE_ID = "SET_COURSE_ID";
export const SET_COURSE_SELECTED_INDEX = "SET_COURSE_SELECTED_INDEX";

export const set_course_id = (id: string) => {
    return{
        type: SET_COURSE_ID,
        payload: id
    }
}

export const set_course_selected_index = (index: number) => {
    return{
        type: SET_COURSE_SELECTED_INDEX,
        payload: index
    }
}